/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_DeleteInputs */

const en_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const fr_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const it_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare`)
};

const ru_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить`)
};

const es_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar`)
};

const zh_cn2_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

const ja_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消去`)
};

const hi_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिटाना`)
};

const pt_pt2_event_group_options_delete = /** @type {(inputs: Event_Group_Options_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Event_Group_Options_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_delete = /** @type {((inputs?: Event_Group_Options_DeleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_DeleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_delete(inputs)
	if (locale === "de") return de_event_group_options_delete(inputs)
	if (locale === "it") return it_event_group_options_delete(inputs)
	if (locale === "ru") return ru_event_group_options_delete(inputs)
	if (locale === "es") return es_event_group_options_delete(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_delete(inputs)
	if (locale === "ja") return ja_event_group_options_delete(inputs)
	if (locale === "hi") return hi_event_group_options_delete(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_delete(inputs)
	return en_event_group_options_delete(inputs)
});